<template>
  <div class="file-container">
    <iframe :data="fileUrl" type="application/pdf" :src="fileUrl" title="File display">
      <embed :src="fileUrl" type="application/pdf" />
    </iframe>
  </div>
</template>

<style scoped>
.file-container {
  height: 100%;
  text-align: center;
}

.file-container object,
.file-container iframe {
  width: 100%;
  height: 100%;
}

</style>

<script>
export default {
  props: {
    currentFile: {
      type: Object,
      required: true,
    },
    moduleLuId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    encodedFilePath() {
      return encodeURIComponent(this.currentFile.path);
    },
    fileUrl() {
      return `/api/static/learning_unit/${this.moduleLuId}/src?path=${this.encodedFilePath}`;
    },
  },
};
</script>
